'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageExposurePlus1 = function ImageExposurePlus1(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z' })
  );
};
ImageExposurePlus1 = (0, _pure2.default)(ImageExposurePlus1);
ImageExposurePlus1.displayName = 'ImageExposurePlus1';
ImageExposurePlus1.muiName = 'SvgIcon';

exports.default = ImageExposurePlus1;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/exposure-plus-1.js
// module id = 3105
// module chunks = 0